import { render, staticRenderFns } from "./PaxelLoader.vue?vue&type=template&id=f9e6e696&scoped=true&"
import script from "./PaxelLoader.vue?vue&type=script&lang=js&"
export * from "./PaxelLoader.vue?vue&type=script&lang=js&"
import style0 from "./PaxelLoader.vue?vue&type=style&index=0&id=f9e6e696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e6e696",
  null
  
)

export default component.exports